import { render, staticRenderFns } from "./XinLvChart.vue?vue&type=template&id=66995861&scoped=true&"
import script from "./XinLvChart.vue?vue&type=script&lang=js&"
export * from "./XinLvChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66995861",
  null
  
)

export default component.exports